import { deriveActivityName } from "../lib/activityName";
import { fmtDate } from "../lib/format";
import {
  comparisonMetricLabel,
  formatComparisonMetric,
  intervalEvidenceCopy,
} from "../lib/activityComparison";

const blank = (value) => (value ? value : "");

export const ActivityCompareTable = ({ comparison, unitSystem = "metric" }) => {
  if (!comparison) return null;
  const sport = comparison.sport;
  const left = comparison.left;
  const right = comparison.right;
  const metrics = comparison.metrics || [];

  return (
    <div className="app-card p-5 space-y-4" data-testid="activity-compare-table">
      <div className="grid grid-cols-3 gap-3 text-sm">
        <div />
        <div data-testid="compare-left-name">
          <div className="text-[10px] tracking-[0.16em] uppercase text-dark-text-muted">{fmtDate(left?.start_time)}</div>
          <div className="text-dark-text-primary">{deriveActivityName(left)}</div>
        </div>
        <div data-testid="compare-right-name">
          <div className="text-[10px] tracking-[0.16em] uppercase text-dark-text-muted">{fmtDate(right?.start_time)}</div>
          <div className="text-dark-text-primary">{deriveActivityName(right)}</div>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[10px] tracking-[0.14em] uppercase text-dark-text-muted">
              <th className="py-2 pr-3 font-normal">Metric</th>
              <th className="py-2 pr-3 font-normal">This activity</th>
              <th className="py-2 font-normal">Compared activity</th>
            </tr>
          </thead>
          <tbody>
            {metrics.map((key) => (
              <tr key={key} className="border-t border-dark-border" data-testid={`compare-row-${key}`}>
                <td className="py-2 pr-3 text-dark-text-secondary">{comparisonMetricLabel(key)}</td>
                <td className="py-2 pr-3" data-testid={`compare-left-${key}`}>
                  {blank(formatComparisonMetric(key, left?.metrics?.[key], { sport, unitSystem }))}
                </td>
                <td className="py-2" data-testid={`compare-right-${key}`}>
                  {blank(formatComparisonMetric(key, right?.metrics?.[key], { sport, unitSystem }))}
                </td>
              </tr>
            ))}
            <tr className="border-t border-dark-border" data-testid="compare-row-intervals">
              <td className="py-2 pr-3 text-dark-text-secondary">Intervals</td>
              <td className="py-2 pr-3" data-testid="compare-left-intervals">
                {blank(left?.intervals?.structure) || intervalEvidenceCopy(left?.intervals)}
              </td>
              <td className="py-2" data-testid="compare-right-intervals">
                {blank(right?.intervals?.structure) || intervalEvidenceCopy(right?.intervals)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
